export default __webpack_public_path__ + "locales/hy-AM/Payments.json?hash=ed43b0d419f993a60b2d19482c5e4334";